import { render, staticRenderFns } from "./AlgorithmView.vue?vue&type=template&id=695d77d4&scoped=true&"
import script from "./AlgorithmView.vue?vue&type=script&lang=js&"
export * from "./AlgorithmView.vue?vue&type=script&lang=js&"
import style0 from "./AlgorithmView.vue?vue&type=style&index=0&id=695d77d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695d77d4",
  null
  
)

export default component.exports